@for (avatar of avatars; track avatar.partyId) {
    @if (avatar) {
        <wdx-avatar-container
            [popupEnabled]="popupEnabled"
            (click)="avatarClicked(avatar)"
            wdxStopPropagation
        >
            <wdx-avatar
                wdxAvatar
                [avatar]="avatar"
                size="sm"
                [borderColor]="(avatars?.length || 0) > 1 ? 'light' : undefined"
            ></wdx-avatar>
            @if (popupEnabled) {
                <div wdxAvatarPopupContent>
                    @if (popupContent$ | ngrxPush; as content) {
                        <wdx-avatar-popup-content
                            wdxAvatarPopupContent
                            [avatar]="avatar"
                            [content]="content"
                        ></wdx-avatar-popup-content>
                    } @else {
                        <div class="w-100 d-flex px-5 py-2 mx-5 my-2">
                            <wdx-spinner></wdx-spinner>
                        </div>
                    }
                </div>
            }
        </wdx-avatar-container>
    }
}

@if (avatars?.length === 1 && label) {
    @if (linkClickCallback) {
        <a
            class="ms-2 flex-1"
            (click)="linkClickCallback()"
            data-cy="avatar-cell-callback"
            >{{ label | translateTokenisedString }}</a
        >
    } @else if (url) {
        @if (newTab) {
            <a
                class="ms-2 flex-1"
                [routerLink]="url"
                data-cy="avatar-cell-link"
                target="_blank"
                >{{ label | translateTokenisedString }}</a
            >
        } @else {
            <a
                class="ms-2 flex-1"
                [routerLink]="url"
                data-cy="avatar-cell-link"
                >{{ label | translateTokenisedString }}</a
            >
        }
    } @else {
        <span class="ms-2 flex-1" data-cy="avatar-cell-label">{{
            label | translateTokenisedString
        }}</span>
    }
}

@if (badge && badge.label) {
    <div
        class="badge"
        [ngClass]="badge.color ? 'badge-' + badge.color : ''"
        data-cy="badge-renderer-badge"
    >
        {{ badge.label | translateTokenisedString }}
    </div>
}
